document.addEventListener("DOMContentLoaded", function () {
  var redirects = {
    "to-tiebacks-med-valgfri-rumparfume": "/pages/to-tiebacks-med-valgfri-rumparfume",
    "en-tassel-med-valgfri-rumparfume": "/pages/en-tassel-med-valgfri-rumparfume",
    "asg000": "/pages/duftproeve-pakke"
  };

  // Hent produktets handle fra URL'en
  var pathname = window.location.pathname;
  var productHandle = pathname.split("/").pop(); // Sidste del af URL'en

  if (redirects[productHandle]) {
    window.location.replace(redirects[productHandle]);
  }
});
